export enum TimeScaleFilterLabel {
  ONE_HOUR = '1h',
  FOUR_HOURS = '4h',
  EIGHT_HOURS = '8h',
  ONE_MONTH = '1m',
}
